import React, { useState, useRef } from 'react'
import { Row, Col, Tabs, Card } from 'antd'

import { connect } from 'react-redux'

import CurrencyExchange from './CurrencyExchange'

import './index.scss'
import {getCurrentCompany} from "../../../../services/user";
import { useConveyer } from "@egjs/react-conveyer";

const TransferBanks: React.FC<any> = ({companyData}) => {
  const { TabPane } = Tabs
  const ref = useRef<HTMLDivElement>(null);
  useConveyer(ref, {
    horizontal: true,
  });
  return (
    <Row className='transfer_child_tabs' ref={ref}>
      <Col span={24} style={{minWidth: "750px"}}>
          <CurrencyExchange />
      </Col>
    </Row>
  )
}

const mapStateToProps = (state: any) => ({
    companyData: (state.user &&  state.user.companyData.result) ?  state.user.companyData.result.customerNo  : getCurrentCompany()
})
export default connect(mapStateToProps, null)(TransferBanks)
